import $ from 'jquery';
import tooltip from 'simple-tooltip';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import CellEditorLoader from '../cell-editor-loader';

export default {
  mixins: [eventListenerMixin],

  properties: {
    key: String,

    editing: {
      type: Boolean,
      default: false,
      observer(editing) {
        this.editingChanged(editing);
        this.namespacedTrigger('cellEditingChange', {
          detail: editing,
          bubbles: true,
        });
      },
    },

    hidden: {
      type: Boolean,
      default: false,
    },

    editable: {
      type: Boolean,
      default: true,
    },

    value: {
      type: String,
      observer(value) {
        if (!value) this.removeAttribute('value');
      },
    },

    editorKey: String,
    editorUrl: String,

    showOverflowTooltip: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.initCellEditorLoader();
    this.initOverflowTooltip();
  },

  beforeCache() {
    if (this.editorLoader) this.editorLoader.clear();
  },

  setValue(value) {
    this.value = value;
  },

  preventClickEvent(event) {
    return this.editable && this.contains(event.target);
  },

  initCellEditorLoader() {
    if (this.editorUrl) {
      this.editorLoader = CellEditorLoader.create({
        key: this.editorKey,
        url: this.editorUrl,
      });
      this.editorLoader.load();
    }
  },

  initOverflowTooltip() {
    if (!this.showOverflowTooltip) return;

    this.listenTo(this, {
      mouseover: this.showOverflowTooltipIfNeeded.bind(this),
      mouseout: this.hideOverflowTooltipIfNeeded.bind(this),
    });
  },

  showOverflowTooltipIfNeeded(event) {
    if (this.editing) return;

    const textContentElement = this.getTextContentElement();
    if (!textContentElement || this.overflowTooltip) return;

    const content = textContentElement.textContent.trim()
      .split('\n').map(v => v.trim()).filter(v => !!v)
      .join(', ');
    if (!content) return;

    const { width: cellWidth } = this.getBoundingClientRect();
    const { scrollWidth: contentWidth } = textContentElement;
    if (contentWidth <= cellWidth) return;

    this.overflowTooltip = tooltip({
      el: this,
      content,
      position: 'top',
    });
    $('.simple-tooltip').remove();
    this.overflowTooltip.show();

    event.stopPropagation();
  },

  hideOverflowTooltipIfNeeded(event) {
    if (this.editing) return;

    if (event.relatedTarget && (
      this === event.relatedTarget || this.contains(event.relatedTarget)
    )) return;

    this.destroyOverflowTooltip();
    event.stopPropagation();
  },

  getTextContentElement() {},

  destroyOverflowTooltip() {
    if (this.overflowTooltip) {
      this.overflowTooltip.destroy();
      this.overflowTooltip = null;
    }
  },

  disconnected() {
    this.stopListening();
    this.destroyOverflowTooltip();
  },

  editingChanged() {},
};
